module.exports = __webpack_public_path__ + "static/img/7.3e29599.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin/7.png
// module id = Tngf
// module chunks = 0